import { InvoiceMissionTypeEnum } from 'src/shared/models/enums/invoiceMissionType.enum';
import { People, RepeatOn, ShoppingCart, VolunteerActivism } from '@mui/icons-material';
import { MainSettingsEnum } from 'src/shared/models/enums/mainSettings.enum';
import { getMainSetting } from 'src/shared/functions/getMainSetting';
import { useGlobals } from 'src/shared/contexts/appContext';
import { useTranslation } from 'react-i18next';
import { InvoiceMissionTypeItem } from '../models/invoiceMissionTypeItem';

type GetInvoiceMissionTypesProps = {
  otherContactMode: boolean;
  showMemberFee: boolean;
};

export const GetInvoiceMissionTypes = (props: GetInvoiceMissionTypesProps): InvoiceMissionTypeItem[] => {
  const { otherContactMode, showMemberFee } = props;
  const { t } = useTranslation(['member', 'invoice']);
  const { currentUser } = useGlobals();
  const invoiceMissionTypes: InvoiceMissionTypeItem[] = [];
  const otherLabel = getMainSetting(currentUser?.mainSettings ?? [], MainSettingsEnum.OtherLabel, t('member:otherContact.pageHeader'));
  const displayLabel = otherContactMode ? otherLabel : t('member:editMember.memberLabel');

  invoiceMissionTypes.push({
    label: t('invoice:createInvoice.invoiceMission.gift'),
    key: InvoiceMissionTypeEnum.Gift,
    icon: <VolunteerActivism />,
  });

  invoiceMissionTypes.push({
    label: t('invoice:createInvoice.invoiceMission.purchase'),
    key: InvoiceMissionTypeEnum.Purchase,
    icon: <ShoppingCart />,
  });

  if (showMemberFee) {
    invoiceMissionTypes.push({
      label: otherContactMode ? displayLabel : t('invoice:createInvoice.invoiceMission.memberfee'),
      key: InvoiceMissionTypeEnum.MemberFee,
      icon: otherContactMode ? <RepeatOn /> : <People />,
    });
  }

  return invoiceMissionTypes;
};
